import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=4d7dfb36&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"
import style0 from "./Table.scss?vue&type=style&index=0&id=4d7dfb36&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7dfb36",
  null
  
)

export default component.exports